import lodash from 'lodash';
const { get } = lodash;
export default function fromTheme(...themePath) {
    return props => {
        let value = get(props.theme, themePath);
        if (typeof value === 'number') {
            return `${value}px`;
        }
        if (typeof value === 'object') {
            // we can just return an object here, and styled components will change pascalCase keys to kebab-case
            // as well as "spread" the object appropriately
            return Object.entries(value || {}).reduce((acc, [key, val]) => {
                acc[key] = typeof val === 'number' ? `${val}px` : val;
                return acc;
            }, {});
        }
        return value;
    };
}
